import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { PublicLayout, ScrollTop } from "@/components/site/PublicLayout";
import { ProtectedRoute } from "@/components/common/ProtectedRoute";
import { DashboardShell } from "@/components/shell/DashboardShell";
import Home from "@/pages/public/Home";
import { Solutions } from "@/pages/public/Solutions";
import CategoryPage from "@/pages/public/CategoryPage";
import ConsultPage from "@/pages/public/ConsultPage";
import ProductPage from "@/pages/public/ProductPage";
import BlogIndex from "@/pages/public/BlogIndex";
import BlogPost from "@/pages/public/BlogPost";
import BulkEnquiry from "@/pages/public/BulkEnquiry";
import Amc from "@/pages/public/Amc";
import VendorRegister from "@/pages/public/VendorRegister";
import { About, Compliance, Contact, Industries } from "@/pages/public/InfoPages";
import Login from "@/pages/public/Login";
import { ForgotPassword, ResetPassword } from "@/pages/public/PasswordReset";
import Projects from "@/pages/public/Projects";
import PortalDashboard from "@/pages/portal/PortalDashboard";
import NewRequest from "@/pages/portal/NewRequest";
import { RequestDetail, RequestList } from "@/pages/portal/Requests";
import Profile from "@/pages/portal/Profile";
import AdminOverview from "@/pages/admin/AdminOverview";
import AdminVendors from "@/pages/admin/AdminVendors";
import AdminEnquiries from "@/pages/admin/AdminEnquiries";
import AdminRequests from "@/pages/admin/AdminRequests";
import AdminTeam from "@/pages/admin/AdminTeam";
import AdminAdvisor from "@/pages/admin/AdminAdvisor";

const PORTAL_NAV = [
  { key: "dashboard", to: "/portal", label: "Dashboard", icon: "LayoutDashboard", end: true },
  { key: "requests", to: "/portal/requests", label: "My requests", icon: "ListChecks" },
  { key: "new", to: "/portal/new/amc", label: "New request", icon: "PlusCircle" },
  { key: "profile", to: "/portal/profile", label: "Company profile", icon: "Building2" },
];

const ADMIN_NAV = [
  { key: "overview", to: "/admin", label: "Overview", icon: "LayoutDashboard", end: true },
  { key: "registrations", to: "/admin/registrations", label: "Registrations", icon: "UserCheck" },
  { key: "enquiries", to: "/admin/enquiries", label: "Enquiries", icon: "Inbox" },
  { key: "requests", to: "/admin/requests", label: "Portal requests", icon: "ClipboardList" },
  { key: "advisor", to: "/admin/advisor", label: "Advisor chats", icon: "MessageSquareText" },
  { key: "team", to: "/admin/team", label: "Admin team", icon: "Users" },
];

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ScrollTop />
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/solutions" element={<Solutions />} />
              <Route path="/solutions/:slug" element={<CategoryPage />} />
              <Route path="/solutions/custom/:slug" element={<ConsultPage />} />
              <Route path="/products/:id" element={<ProductPage />} />
              <Route path="/blog" element={<BlogIndex />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/services/:slug" element={<ConsultPage />} />
              <Route path="/amc" element={<Amc />} />
              <Route path="/enquiry" element={<BulkEnquiry />} />
              <Route path="/register" element={<VendorRegister />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/about" element={<About />} />
              <Route path="/industries" element={<Industries />} />
              <Route path="/compliance" element={<Compliance />} />
              <Route path="/contact" element={<Contact />} />
            </Route>
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/portal" element={<ProtectedRoute role="vendor"><DashboardShell items={PORTAL_NAV} badge="Vendor portal" /></ProtectedRoute>}>
              <Route index element={<PortalDashboard />} />
              <Route path="requests" element={<RequestList />} />
              <Route path="requests/:id" element={<RequestDetail />} />
              <Route path="new/:type" element={<NewRequest />} />
              <Route path="profile" element={<Profile />} />
            </Route>
            <Route path="/admin" element={<ProtectedRoute role="admin"><DashboardShell items={ADMIN_NAV} badge="Admin console" /></ProtectedRoute>}>
              <Route index element={<AdminOverview />} />
              <Route path="registrations" element={<AdminVendors />} />
              <Route path="enquiries" element={<AdminEnquiries />} />
              <Route path="requests" element={<AdminRequests />} />
              <Route path="team" element={<AdminTeam />} />
              <Route path="advisor" element={<AdminAdvisor />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-right" richColors closeButton />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
